export const MARKETING_LOAD_TEMPLATES = "MARKETING_LOAD_TEMPLATES";
export const MARKETING_LOAD_TEMPLATES_SELECTED =
  "MARKETING_LOAD_TEMPLATES_SELECTED";
export const MARKETING_UPDATE_TEMPLATES_SELECTED =
  "MARKETING_UPDATE_TEMPLATES_SELECTED";
export const MARKETING_EMAIL_CONFIG = "MARKETING_EMAIL_CONFIG";
export const MAKRETING_LOAD_TEMPLATE_ELASTIC =
  "MAKRETING_LOAD_TEMPLATE_ELASTIC";
export const MARKETING_PUSH_COUNT_DISTINCT_ENVIOS =
  "MARKETING_PUSH_COUNT_DISTINCT_ENVIOS";
